export const InsuranceProducts = [{
  type: 'International Escapes',
  title: 'Comprehensive Trip Protection + COVID Cover',
  benefits: [
    {
      text:
        'Refund bookings for you or your ticket holders at anytime if need to cancel due to illness or injury,',
      includingCovid: true,
    },
    {
      text: 'Medical assistance and treatment,',
      includingCovid: true,
    },
    {
      text:
        'Money back for emergency expenses, including accommodation, transport and food',
      includingCovid: false,
    },
    {
      text: 'Cover for damaged or stolen personal items',
      includingCovid: false,
    },
  ],
  complementaryText: 'Not covered: Pre-existing medical conditions.',
}, {
  type: 'International Escapes',
  title: 'Overseas Medical and Evacuation + COVID Cover',
  benefits: [
    {
      text: 'Medical assistance and treatment during your trip,',
      includingCovid: true,
    },
    {
      text: 'Emergency flights and evacuation',
      includingCovid: false,
    },
    {
      text:
        'Money back for emergency expenses, including accommodation, transport and food,',
      includingCovid: true,
    },
  ],
  complementaryText: 'Please note: This cover will not allow a refund if you or another person you’re travelling with needs to cancel your trip prior to departure due to illness or injury including Covid-19',
}, {
  type: 'Domestic Escapes',
  title: 'Cancellation and Baggage protection + COVID Cover',
  blurb: 'If any travellers need to cancel or cut short the trip due to the illness or death of yourself or a close family member...',
  benefits: [
    {
      text: 'your Luxury Escapes package costs will be reimbursed.',
      includingCovid: false,
    },
    {
      text: 'cover for damaged or stolen personal items.',
      includingCovid: false,
    },
    {
      text: 'payments are made instantly into your currency and bank account.',
      includingCovid: false,
    },
  ],
}]
